import { render, staticRenderFns } from "./addDepartmentForm.vue?vue&type=template&id=14739e22&"
import script from "./addDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./addDepartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports